import { create } from 'zustand';
import {
  CustomerFactorType,
  PurchasesDataType
} from '../../Types/purchases.type';
import { getPurchasesDataAction, setHasMoreDataAction } from './action';

type PurchasesType = {
  purchasesData: PurchasesDataType;
  purchasesLoading: boolean;
  purchasesError: boolean;
  getPurchasesDataAction: (body: {
    clubBranchId: number;
    skip: number;
    take: number;
  }) => Promise<CustomerFactorType[]>;
  hasMoreData: boolean;
  setHasMoreDataAction: (hasMore: boolean) => void;
};

const usePurchasesStore = create<PurchasesType>((set) => ({
  purchasesData: null,
  purchasesLoading: false,
  purchasesError: false,
  hasMoreData: true,
  getPurchasesDataAction: (body) => getPurchasesDataAction(set, body),
  setHasMoreDataAction: (hasMore) => setHasMoreDataAction(set, hasMore)
}));

export default usePurchasesStore;
